import { Stroke } from '../../utils/editorReactIcons';
export { Stroke };
export default Stroke;
